function addToCartWizard() {
  const url = new URL(window.location.href);
  const storageKey = `bundle-kit-state:${window.location.pathname}`;
  return {
    step: 1,
    steps: ["Crisps", "Spud Dust", "Shake Bags", "Tub"],
    bagsCount: 0,
    shakerCount: 0,
    bagPrice: 9.99,
    numberOf: 5,
    shakeBagsCount: 5,
    cartLoading: false,
    hoveredCrisp:
      "The perfect crisp, heavier than a Walkers, lighter than a Kettle with the perfect crunch.",
    _scrollListenerAdded: false,
    isFlavor: false,
    soldOutCrisps:
      typeof soldOutCrisps !== "undefined" && Array.isArray(soldOutCrisps)
        ? soldOutCrisps.map((name) => String(name).toLowerCase())
        : [],
    crisps: [
      {
        id: 1,
        name: "Crisps",
        img: crisps[0],
        blurb:
          "The perfect crisp, heavier than a Walkers, lighter than a Kettle with the perfect crunch.",
        count: 0,
        itemId: 56958933205379,
        allergen: `<div class=has-motion><div class="cf rte"><p><meta charset=utf-8><meta charset=utf-8><strong data-mce-fragment=1>Crisps Nutritional Information</strong><br><div class=nutrition_information><table width=100%><tr><td style=width:192px><strong>Average</strong><td style=width:128.047px><strong>Per 100g</strong><td style=width:208.953px><strong>Per 30g Serving</strong><tr><td style=width:192px><strong>Energy</strong><td style=width:128.047px>2218 kJ<br>533 kcal<td style=width:208.953px>665 kJ<br>160 kcal<br><tr><td style=width:192px><strong>Fat</strong><td style=width:128.047px>33.5g<br><td style=width:208.953px>10g<br><tr><td style=width:192px>    Saturated<td style=width:128.047px>3.82g<br><td style=width:208.953px>1.1g<br><tr><td style=width:192px><strong>Carbohydrates</strong><br><td style=width:128.047px>57.8g<br><td style=width:208.953px>17.3g<br><tr><td style=width:192px>    Sugars<td style=width:128.047px>&lt;0.1g<br><td style=width:208.953px><meta charset=utf-8><span data-mce-fragment=1>&lt;0.1g</span><br><tr><td style=width:192px><strong>Fibre</strong><td style=width:128.047px><meta charset=utf-8>7.7g<br><td style=width:208.953px>2.31g<br><tr><td style=width:192px><strong>Protein</strong><td style=width:128.047px>3.8g<br><td style=width:208.953px>1.1g<br><tr><td style=width:192px><strong>Salt</strong><td style=width:128.047px>0g<br><td style=width:208.953px>0g<br></table><strong>Ingredients<br></strong>Potatoes, Rapeseed Oil.</div></div></div>`,
      },
      {
        id: 2,
        name: "Chip Sticks",
        img: crisps[3],
        blurb:
          "The best chip sticks you've ever tasted, they're longer with the ultimate crunch.",
        count: 0,
        itemId: 56958932877699,
        allergen: `<div class=has-motion><div class="cf rte"><p><meta charset=utf-8><meta charset=utf-8><strong data-mce-fragment=1>Chip Sticks Nutritional Information</strong><br><div class=nutrition_information><table width=100%><tr><td style=width:192px><strong>Average</strong><td style=width:128.047px><strong>Per 100g</strong><td style=width:208.953px><strong>Per 30g Serving</strong><tr><td style=width:192px><strong>Energy</strong><td style=width:128.047px>2218 kJ<br>533 kcal<td style=width:208.953px>665 kJ<br>160 kcal<br><tr><td style=width:192px><strong>Fat</strong><td style=width:128.047px>33.5g<br><td style=width:208.953px>10g<br><tr><td style=width:192px>    Saturated<td style=width:128.047px>3.82g<br><td style=width:208.953px>1.1g<br><tr><td style=width:192px><strong>Carbohydrates</strong><br><td style=width:128.047px>57.8g<br><td style=width:208.953px>17.3g<br><tr><td style=width:192px>    Sugars<td style=width:128.047px>&lt;0.1g<br><td style=width:208.953px><meta charset=utf-8><span data-mce-fragment=1>&lt;0.1g</span><br><tr><td style=width:192px><strong>Fibre</strong><td style=width:128.047px><meta charset=utf-8>7.7g<br><td style=width:208.953px>2.31g<br><tr><td style=width:192px><strong>Protein</strong><td style=width:128.047px>3.8g<br><td style=width:208.953px>1.1g<br><tr><td style=width:192px><strong>Salt</strong><td style=width:128.047px>0g<br><td style=width:208.953px>0g<br></table><strong>Ingredients<br></strong>Potatoes, Rapeseed Oil.</div></div></div>`,
      },
      {
        id: 3,
        name: "Crinkle Cuts",
        img: crisps[2],
        blurb:
          "The perfect crinkle, not too deep, not too shallow, full of crunch and flavour.",
        count: 0,
        itemId: 56958907089283,
        allergen: `<div class=has-motion><div class="cf rte"><p><meta charset=utf-8><meta charset=utf-8><strong data-mce-fragment=1>Crinkle Cuts Nutritional Information</strong><br><div class=nutrition_information><table width=100%><tr><td style=width:192px><strong>Average</strong><td style=width:128.047px><strong>Per 100g</strong><td style=width:208.953px><strong>Per 30g Serving</strong><tr><td style=width:192px><strong>Energy</strong><td style=width:128.047px>2218 kJ<br>533 kcal<td style=width:208.953px>665 kJ<br>160 kcal<br><tr><td style=width:192px><strong>Fat</strong><td style=width:128.047px>33.5g<br><td style=width:208.953px>10g<br><tr><td style=width:192px>    Saturated<td style=width:128.047px>3.82g<br><td style=width:208.953px>1.1g<br><tr><td style=width:192px><strong>Carbohydrates</strong><br><td style=width:128.047px>57.8g<br><td style=width:208.953px>17.3g<br><tr><td style=width:192px>    Sugars<td style=width:128.047px>&lt;0.1g<br><td style=width:208.953px><meta charset=utf-8><span data-mce-fragment=1>&lt;0.1g</span><br><tr><td style=width:192px><strong>Fibre</strong><td style=width:128.047px><meta charset=utf-8>7.7g<br><td style=width:208.953px>2.31g<br><tr><td style=width:192px><strong>Protein</strong><td style=width:128.047px>3.8g<br><td style=width:208.953px>1.1g<br><tr><td style=width:192px><strong>Salt</strong><td style=width:128.047px>0g<br><td style=width:208.953px>0g<br></table><strong>Ingredients<br></strong>Potatoes, Rapeseed Oil.</div></div></div>`,
      },
      {
        id: 4,
        name: "Dunks",
        img: crisps[1],
        blurb:
          "Delicious potato crunchy bites the size of a Hula Hoop and a little crunchier than an onion ring.",
        count: 0,
        itemId: 56958930485635,
        allergen: `<div class=has-motion><div class="cf rte"><p><meta charset=utf-8><meta charset=utf-8><strong data-mce-fragment=1>Dunks Nutritional Information</strong><br><div class=nutrition_information><table style=height:211.938px;width:98.2124% width=474><tr style=height:19.5938px><td style=width:192px><strong>Average</strong><td style=width:128.047px><strong>Per 100g</strong><td style=width:208.953px><strong>Per 25g Serving</strong><tr style=height:39.1875px><td style=width:192px><strong>Energy</strong><td style=width:128.047px>1838 kJ<br>437 kcal<td style=width:208.953px>459.5 kJ<br>109.25 kcal<br><tr style=height:19.5938px><td style=width:192px><strong>Fat</strong><td style=width:128.047px>13.2g<br><td style=width:208.953px>3.3g<br><tr style=height:19.5938px><td style=width:192px>    Saturated<td style=width:128.047px>1.0g<br><td style=width:208.953px>0.25g<br><tr style=height:19.5938px><td style=width:192px><strong>Carbohydrates</strong><br><td style=width:128.047px>74.9g<br><td style=width:208.953px>18.73g<br><tr style=height:19.5938px><td style=width:192px>    Sugars<td style=width:128.047px>0.2g<br><td style=width:208.953px><meta charset=utf-8><span data-mce-fragment=1>&lt;0.1g</span><br><tr style=height:19.5938px><td style=width:192px><strong>Fibre</strong><td style=width:128.047px><meta charset=utf-8>3.5g<br><td style=width:208.953px>0.88g<br><tr style=height:19.5938px><td style=width:192px><strong>Protein</strong><td style=width:128.047px>2.9g<br><td style=width:208.953px>0.73g<br><tr style=height:35.5938px><td style=width:192px><strong>Salt</strong><td style=width:128.047px>2.91g<br><td style=width:208.953px>0.73g<br></table><strong>Ingredients<br></strong>Potato Starch, Potato Granuals, Rapeseed Oil, Pre-Gelatinised Potato Starch, Salt, Vegetable based distilled mono-glyceride.</div></div></div>`,
      },
    ],
    flavors: [
      {
        id: 1,
        name: "Beef Bourguignon",
        link: "/collections/spud-dust/products/beef-bourguignon",
        blurb:
          "The incredible tasting notes of steak, mushrooms and red wine. ",
        img: imgs[0],
        count: 0,
        itemId: 57754722206083,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutritional Information</strong><table style=height:215.532px width=100%><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Average</strong><td style=width:128.047px;height:19.5938px><strong>Per 100g</strong><td style=width:208.953px;height:19.5938px><strong>Per 5g Serving</strong><tr style=height:39.1875px><td style=width:192px;height:39.1875px><strong>Energy</strong><td style=width:128.047px;height:39.1875px>1177 kJ<br>280 kcal<td style=width:208.953px;height:39.1875px>58.85 kJ<br>14 kcal<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Fat</strong><td style=width:128.047px;height:19.5938px>0.82g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8><meta charset=utf-8><span>&lt; 0.1g</span><br><tr style=height:19.5938px><td style=width:192px;height:19.5938px>    Saturated<td style=width:128.047px;height:19.5938px><meta charset=utf-8>0.2g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8><span>&lt; 0.1g</span><br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Carbohydrates</strong><br><td style=width:128.047px;height:19.5938px>51.58g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>2.58g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px>    Sugars<td style=width:128.047px;height:19.5938px><meta charset=utf-8>20.26g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>1.01g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Fibre</strong><td style=width:128.047px;height:19.5938px>4.07g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>0.2g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Protein</strong><td style=width:128.047px;height:19.5938px><meta charset=utf-8>14.63g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>0.73g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Salt</strong><td style=width:128.047px;height:19.5938px>17.82g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>0.89g</table><p> <br><strong><span>Beef Bourguignon </span>Spud Dust <meta charset=utf-8>Ingredients<br></strong>Yeast Extract, Salt, Mushroom Extract Powder, Sugar, Balsamic Vinegar Powder, Garlic Powder, Onion Powder, Spirit Vinegar Powder, Caramelised Sugar Powder, Red Beetroot Powder, Herbs (Parsley, Thyme), Spices (Black Pepper), Acid E330, Natural Flavouring.<br><p><strong><span>Beef Bourguignon </span>Spud Dust Allergens in Bold.</strong><br><p>Store in a cool dry place out of direct sunlight.<p><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. </div></div>`,
      },
      {
        id: 2,
        name: "Southern Fried Chicken",
        link: "/collections/spud-dust/products/southern-fried-chicken-spud-dust",
        blurb: "The perfect blend of secret spices!",
        img: imgs[1],
        count: 0,
        itemId: 44364244713727,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr style=height:19px><td style=width:192px;height:19px><strong>Average</strong><td style=width:128.047px;height:19px><strong>Per 100g</strong><td style=width:208.953px;height:19px><strong>Per 5g Serving</strong><tr style=height:39px><td style=width:192px;height:39px><strong>Energy</strong><td style=width:128.047px;height:39px>1233 kJ<br>293 kcal<td style=width:208.953px;height:39px>61.65 kJ<br>14.654 kcal<br><tr style=height:19px><td style=width:192px;height:19px><strong>Fat</strong><td style=width:128.047px;height:19px>1.74g<br><td style=width:208.953px;height:19px><meta charset=utf-8><span data-mce-fragment=1>&lt; 0.1g</span><br><tr style=height:19px><td style=width:192px;height:19px>    Saturated<td style=width:128.047px;height:19px><meta charset=utf-8>0.47g<br><td style=width:208.953px;height:19px><meta charset=utf-8><span data-mce-fragment=1>&lt; 0.1g</span><br><tr style=height:19px><td style=width:192px;height:19px><strong>Carbohydrates</strong><br><td style=width:128.047px;height:19px>51.39g<br><td style=width:208.953px;height:19px><meta charset=utf-8>2.56g<br><tr><td style=width:192px>    Sugars<td style=width:128.047px><meta charset=utf-8>3.47g<br><td style=width:208.953px><meta charset=utf-8>0.17g<br><tr><td style=width:192px>    Starch<td style=width:128.047px>1.14g<td style=width:208.953px><meta charset=utf-8><span>&lt; 0.1g</span><tr style=height:19px><td style=width:192px;height:19px><strong>Fibre</strong><td style=width:128.047px;height:19px>8.07g<br><td style=width:208.953px;height:19px><meta charset=utf-8>0.40g<br><tr style=height:19px><td style=width:192px;height:19px><strong>Protein</strong><td style=width:128.047px;height:19px><meta charset=utf-8>14.09g<br><td style=width:208.953px;height:19px><meta charset=utf-8>0.70g<br><tr style=height:19px><td style=width:192px;height:19px><strong>Salt</strong><td style=width:128.047px;height:19px>16.38g<br><td style=width:208.953px;height:19px><meta charset=utf-8>0.81g<br></table></div><p><br><p><strong>Ingredients</strong><br>Rice Flour, Yeast Extract, Onion Powder, Spices (Black Pepper, Paprika, Mace, Fennel, Ginger), Salt, Garlic Powder, Herbs (Oregano, Thyme), Spice Extract<br><p><strong>Allergens</strong><br>None<p>Store in a cool dry place out of direct sunlight.<p><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. </div></div>`,
      },
      // {
      //   id: 3,
      //   name: "Döner Kebab",
      //   link: "/collections/spud-dust/products/doner-kebab-spud-dust",
      //   blurb:
      //     "It’s meaty, oniony, tomatoy, spicy, salty, yoghurty, garlicy, minty.",
      //   img: imgs[2],
      //   count: 0,
      //   itemId: 43953651089663,
      //   allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr><td style=width:192px><strong>Average</strong><td style=width:128.047px><strong>Per 100g</strong><td style=width:208.953px><strong>Per 5g Serving</strong><tr><td style=width:192px><strong>Energy</strong><td style=width:128.047px>1293 kJ<br>308 kcal<td style=width:208.953px>64.65 kJ<br>15.4 kcal<br><tr><td style=width:192px><strong>Fat</strong><td style=width:128.047px><meta charset=utf-8>6.49g<br><td style=width:208.953px><meta charset=utf-8>0.32g<br><tr><td style=width:192px>    Saturated<td style=width:128.047px><meta charset=utf-8>0.74g<br><td style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td style=width:192px><strong>Carbohydrates</strong><br><td style=width:128.047px><meta charset=utf-8>41.6g<br><td style=width:208.953px><meta charset=utf-8>2.08g<br><tr><td style=width:192px>    Sugars<td style=width:128.047px><meta charset=utf-8>3.47g<br><td style=width:208.953px><meta charset=utf-8>0.17g<br><tr><td style=width:192px><strong>Fibre</strong><td style=width:128.047px><meta charset=utf-8>10.78g<br><td style=width:208.953px><meta charset=utf-8>0.54g<br><tr><td style=width:192px><strong>Protein</strong><td style=width:128.047px><meta charset=utf-8>15.39g<br><td style=width:208.953px><meta charset=utf-8>0.77g<br><tr><td style=width:192px><strong>Salt</strong><td style=width:128.047px><meta charset=utf-8>18.23g<br><td style=width:208.953px><meta charset=utf-8>0.91g<br></table></div><p><br><p><strong>Ingredients</strong><br><meta charset=utf-8><span data-mce-fragment=1>Spices (Coriander, Cumin, Cayenne, Black Pepper), Rice Flour, Yeast Extract, Salt, Onion Powder, Garlic Powder, Garam Masala (coriander, cumin, black pepper, allspice, cardamom, nutmeg, turmeric, ginger, bay, clove, cassia, cayenne) contains, Acid E330, Natural Flavouring, Herbs (Mint), Dextrose, Mint Extract.</span><br><p><strong>Allergies</strong><br>None<p>Store in a cool dry place out of direct sunlight.<br><br><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. <br></div></div>`,
      // },
      {
        id: 4,
        name: "Salt & Vinegar",
        link: "/collections/spud-dust/products/salt-vinegar-spud-dust",
        blurb: "An absolute classic.",
        img: imgs[3],
        count: 0,
        itemId: 42295228694783,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Average</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><strong>Per 100g</strong><td data-mce-style="width: 208.953px;"style=width:208.953px><strong>Per 5g Serving</strong><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Energy</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>1190 kJ<br>283 kcal<td data-mce-style="width: 208.953px;"style=width:208.953px>59.5 kJ<br>14.2 kcal<tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fat</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>3.03g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>0.2g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Saturated<td data-mce-style="width: 128.047px;"style=width:128.047px>0g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>0g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Carbohydrates</strong><br><td data-mce-style="width: 128.047px;"style=width:128.047px>60.91g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>3g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Sugars<td data-mce-style="width: 128.047px;"style=width:128.047px>9.33g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>0.5g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fibre</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>0.16g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Protein</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>3.07g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>0.2g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Salt</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>21.51g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>1.1g<br></table></div><p><br><p><strong>Ingredients</strong><br>Spirit Vinegar, Salt, Yeast Extract, Maltodextrin, Citric Acid, Sugar.<p><strong>Allergies</strong><br>None<p>Store in a cool dry place out of direct sunlight.<br><br><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. <br></div></div>`,
      },
      {
        id: 5,
        name: "Prawn Cocktail",
        link: "/collections/spud-dust/products/prawn-cocktail-spud-dust",
        blurb:
          "The subtlety of prawn and the traditional posh dusting of paprika.",
        img: imgs[4],
        count: 0,
        itemId: 43718375112959,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Average</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><strong>Per 100g</strong><td data-mce-style="width: 208.953px;"style=width:208.953px><strong>Per 5g Serving</strong><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Energy</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>1078 kJ<br>257 kcal<td data-mce-style="width: 208.953px;"style=width:208.953px>53.9 kJ<br>12.8 kcal<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fat</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>1.21g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8><span data-mce-fragment=1>&lt; 0.1g</span><br><tr><td data-mce-style="width: 192px;"style=width:192px>    Saturated<td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>0.17g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Carbohydrates</strong><br><td data-mce-style="width: 128.047px;"style=width:128.047px>53.76.6g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>2.7g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Sugars<td data-mce-style="width: 128.047px;"style=width:128.047px>34.29g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>1.7g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fibre</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>2.30g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Protein</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>6.52g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.3g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Salt</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>17.75g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.9g<br></table></div><p><br><p><strong>Ingredients<br></strong>Rice Flour, Sugar, Salt, Dextrose, Acidity Regulator E262(ii), Yeast Extract, Acid E330, Onion Powder, Icing Sugar, Tomato Powder, Spices (Cayenne), Natural Flavouring, Paprika Extract, Spice Extract<p><strong>Allergies</strong><br>None<p>Store in a cool dry place out of direct sunlight.<br><br><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. <br></div></div>`,
      },
      {
        id: 6,
        name: "Chip Shop Curry",
        link: "/collections/spud-dust/products/chip-shop-curry-spud-dust",
        blurb: "It's Chip Shop Curry sauce flavour without the attitude.",
        img: imgs[5],
        count: 0,
        itemId: 43968361103615,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr><td style=width:192px><strong>Average</strong><td style=width:128.047px><strong>Per 100g</strong><td style=width:208.953px><strong>Per 5g Serving</strong><tr><td style=width:192px><strong>Energy</strong><td style=width:128.047px>1414 kJ<br>336 kcal<td style=width:208.953px>70.7 kJ<br>16.8 kcal<br><tr><td style=width:192px><strong>Fat</strong><td style=width:128.047px><meta charset=utf-8>3.04g<br><td style=width:208.953px><meta charset=utf-8>0.2g<br><tr><td style=width:192px>    Saturated<td style=width:128.047px><meta charset=utf-8>0.45g<br><td style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td style=width:192px><strong>Carbohydrates</strong><br><td style=width:128.047px><meta charset=utf-8>65.6g<br><td style=width:208.953px><meta charset=utf-8>3.3g<br><tr><td style=width:192px>    Sugars<td style=width:128.047px><meta charset=utf-8>27.68g<br><td style=width:208.953px><meta charset=utf-8>1.4g<br><tr><td style=width:192px><strong>Fibre</strong><td style=width:128.047px><meta charset=utf-8>7.21g<br><td style=width:208.953px><meta charset=utf-8>0.4g<br><tr><td style=width:192px><strong>Protein</strong><td style=width:128.047px><meta charset=utf-8>8.14g<br><td style=width:208.953px><meta charset=utf-8>0.4g<br><tr><td style=width:192px><strong>Salt</strong><td style=width:128.047px><meta charset=utf-8>14.67g<br><td style=width:208.953px><meta charset=utf-8>0.7g<br></table></div><p><br><p><strong>Ingredients</strong><br>Spices (cumin, coriander, turmeric, fennel, fenugreek, cayenne, black pepper), Sugar, Salt, Onion Powder, Yeast Extract, Garlic Powder, Maltodextrin, Tomato Powder, Paprika Extract.<p><strong>Allergies</strong><br>None<p>Store in a cool dry place out of direct sunlight.<p>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. </div></div>`,
      },
      {
        id: 7,
        name: "Crispy Bacon",
        link: "/collections/spud-dust/products/david-bacon-spud-dust",
        blurb: "This isn't just any old bacon flavour, this is Crispy Bacon! ",
        img: imgs[6],
        count: 0,
        itemId: 42295222272255,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Average</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><strong>Per 100g</strong><td data-mce-style="width: 208.953px;"style=width:208.953px><strong>Per 5g Serving</strong><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Energy</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>1380 kJ<br>328 kcal<td data-mce-style="width: 208.953px;"style=width:208.953px>69.01 kJ<br>16.4 kcal<tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fat</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>0.62g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Saturated<td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>0.24g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Carbohydrates</strong><br><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>75.76g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>3.8g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Sugars<td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>20.01g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fibre</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>0.65g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Protein</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>4.68g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.2g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Salt</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>15.12g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.8g<br></table></div><p><br><p><strong>Ingredients</strong><br>Salt, Yeast Extract, Spices (black pepper, cayenne, clove, pimento), Sugar, Flavouring, Paprika Extract, Maltodextrin, Dextrose, Spice Extract <br><p><strong>Allergens</strong><br>None<p>Store in a cool dry place out of direct sunlight.<br><br><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. <br></div></div>`,
      },
      {
        id: 8,
        name: "Nooch & Onion",
        link: "/collections/spud-dust/products/nooch-onion-spud-dust",
        blurb: `Nooch has a nutty cheese flavour, but it's jam packed with nutrients.`,
        img: imgs[7],
        count: 0,
        itemId: 42295226630399,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Average</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><strong>Per 100g</strong><td data-mce-style="width: 208.953px;"style=width:208.953px><strong>Per 5g Serving</strong><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Energy</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>1370 kJ<br>326 kcal<td data-mce-style="width: 208.953px;"style=width:208.953px>68.5 kJ<br>16.3 kcal<tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fat</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>0.26g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Saturated<td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>0.27g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Carbohydrates</strong><br><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>72.65g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>3.6g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Sugars<td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>13.84g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.7g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fibre</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>1.86g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Protein</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>7.44g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.4g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Salt</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>14.69g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.7g<br></table></div><p><br><p><strong>Ingredients</strong><br>Yeast Extract, Onion Powder (<strong>sulphites</strong>), Sugar (<strong>sulphites</strong>), Paprika Extract, Maltodextrin (<strong>sulphites</strong>), Salt, Natural Flavouring.<br><p><strong>Allergies</strong><br>In bold.<br><p>Store in a cool dry place out of direct sunlight.<br><br><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. <br></div></div>`,
      },
      {
        id: 9,
        name: "Nduja & Honey",
        link: "/collections/spud-dust/products/nduja-honey",
        blurb: "Rich Italian salami with sweet and smooth honey.",
        img: imgs[8],
        count: 0,
        itemId: 46066337218815,
        allergen: `<div class="has-motion"><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table style=height:195.938px width=100%><tr style=height:19.5938px><td style=width:192px><strong>Average</strong><td style=width:128.047px><strong>Per 100g</strong><td style=width:208.953px><strong>Per 5g Serving</strong><tr style=height:39.1875px><td style=width:192px><strong>Energy</strong><td style=width:128.047px>1322.5 kJ<br>331.9 kcal<td style=width:208.953px>66.1 kJ<br>16.6 kcal<br><tr style=height:19.5938px><td style=width:192px><strong>Fat</strong><td style=width:128.047px><meta charset=utf-8> 3.43g<br><td style=width:208.953px><meta charset=utf-8> 0.17g<br><tr style=height:19.5938px><td style=width:192px>    Saturated<td style=width:128.047px><meta charset=utf-8> 0.64g<br><td style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr style=height:19.5938px><td style=width:192px><strong>Carbohydrates</strong><br><td style=width:128.047px><meta charset=utf-8>57.4g<br><td style=width:208.953px><meta charset=utf-8>2.87g<br><tr style=height:19.5938px><td style=width:192px>    Sugars<td style=width:128.047px><meta charset=utf-8>44.2g<br><td style=width:208.953px><meta charset=utf-8>2.21g<br><tr style=height:19.5938px><td style=width:192px><strong>Fibre</strong><td style=width:128.047px><meta charset=utf-8> 7.20g<br><td style=width:208.953px><meta charset=utf-8> 0.36g<br><tr style=height:19.5938px><td style=width:192px><strong>Protein</strong><td style=width:128.047px><meta charset=utf-8>10g<br><td style=width:208.953px><meta charset=utf-8> 0.5g<br><tr style=height:19.5938px><td style=width:192px><strong>Salt</strong><td style=width:128.047px><meta charset=utf-8> 17.7g<br><td style=width:208.953px><meta charset=utf-8> 0.88g<br></table></div><p><br><p><strong>Ingredients</strong><br><meta charset=utf-8><span dir=ltr role=presentation>Spices (Cayenne, Paprika), Sugar, Dextrose, Salt, Yeast Extract, Icing Sugar, Garlic </span><span dir=ltr role=presentation>Powder, Natural Flavouring, </span><span dir=ltr role=presentation>Acid E330, Paprika Extract, Spice Extract.</span><span dir=ltr role=presentation></span><br><p><strong>Allergies</strong><br>None<p>Store in a cool dry place out of direct sunlight.<br><br><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. <br></div></div>`,
      },
      {
        id: 10,
        name: "Vindaloo",
        link: "/collections/spud-dust/products/vindaloo-spud-dust",
        blurb: "It's smokey, meaty and very very spicy.",
        img: imgs[9],
        count: 0,
        itemId: 56630240969091,
        allergen: `<div class="has-motion"><div class="cf rte"><p><strong>Nutritional Information</strong><table style=height:215.532px width=100%><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Average</strong><td style=width:128.047px;height:19.5938px><strong>Per 100g</strong><td style=width:208.953px;height:19.5938px><strong>Per 5g Serving</strong><tr style=height:39.1875px><td style=width:192px;height:39.1875px><strong>Energy</strong><td style=width:128.047px;height:39.1875px>1253 kJ<br>298 kcal<td style=width:208.953px;height:39.1875px>62.65 kJ<br>14.9 kcal<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Fat</strong><td style=width:128.047px;height:19.5938px>2.51g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8><span>0.12g</span><br><tr style=height:19.5938px><td style=width:192px;height:19.5938px>    Saturated<td style=width:128.047px;height:19.5938px><meta charset=utf-8>0.47g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8><span>&lt; 0.1g</span><br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Carbohydrates</strong><br><td style=width:128.047px;height:19.5938px>51.88g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>2.59g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px>    Sugars<td style=width:128.047px;height:19.5938px><meta charset=utf-8>23.68g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>1.18g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Fibre</strong><td style=width:128.047px;height:19.5938px>10.96g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>0.55g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Protein</strong><td style=width:128.047px;height:19.5938px><meta charset=utf-8>11.48g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>0.58g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Salt</strong><td style=width:128.047px;height:19.5938px>17.89g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>0.89g</table><p> <br><strong><span>Vindaloo </span>Spud Dust <meta charset=utf-8>Ingredients<br></strong>Tomato Powder, Salt, Spices (Ginger, Coriander, Cardamom, Cumin, Paprika, Turmeric) (<strong>SULPHITES</strong>), Onion Powder (<strong>SULPHITES</strong>), Sugar (<strong>SULPHITES</strong>), Garlic Powder (<strong>SULPHITES</strong>), Curry Powder (Spices Coriander, Fenugreek, Turmeric, Cayenne, Cumin, Black Pepper, Paprika), Rice Flour, Salt, Potato Starch, Whole Caraway Seed, Whole Fennel Seed, Garlic Powder, Onion Powder (<strong>SULPHITES</strong>), Yeast Extract, Spirit Vinegar Powder, Ghost Chilli Powder / Naga Chilli Powder, Acid E330, Paprika Extract, Natural Flavouring.<br><p><strong><span>Vindaloo </span>Spud Dust Allergens in Bold.</strong><br><span>Sulphites.</span><p>Store in a cool dry place out of direct sunlight.<p><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. </div></div>`,
      },
      {
        id: 11,
        name: "Pickled Gherkin",
        link: "/collections/spud-dust/products/pickled-gherkin",
        blurb: "Pickle lovers unite! You know who you are.",
        img: imgs[10],
        count: 0,
        itemId: 56889545884035,
        allergen: `<div class="has-motion"><div class="cf rte"><p><strong>Nutritional Information</strong><table style=height:215.532px width=100%><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Average</strong><td style=width:128.047px;height:19.5938px><strong>Per 100g</strong><td style=width:208.953px;height:19.5938px><strong>Per 5g Serving</strong><tr style=height:39.1875px><td style=width:192px;height:39.1875px><strong>Energy</strong><td style=width:128.047px;height:39.1875px>1151 kJ<br>274 kcal<td style=width:208.953px;height:39.1875px>57.55 kJ<br>13.7 kcal<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Fat</strong><td style=width:128.047px;height:19.5938px>3.46g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8><span>0.17g</span><br><tr style=height:19.5938px><td style=width:192px;height:19.5938px>    Saturated<td style=width:128.047px;height:19.5938px><meta charset=utf-8>0.36g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8><span>&lt; 0.1g</span><br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Carbohydrates</strong><br><td style=width:128.047px;height:19.5938px>50.50g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>2.52g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px>    Sugars<td style=width:128.047px;height:19.5938px><meta charset=utf-8>21.39g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>1.07g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Fibre</strong><td style=width:128.047px;height:19.5938px>6.12g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>0.31g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Protein</strong><td style=width:128.047px;height:19.5938px><meta charset=utf-8>7.15g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>0.36g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Salt</strong><td style=width:128.047px;height:19.5938px>17.78g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>0.89g</table><p> <br><strong><span>Pickled Gherkin </span>Spud Dust <meta charset=utf-8>Ingredients<br></strong>Sugar, Spirit Vinegar Powder, Spices (Dill, Cayenne, Caraway, Coriander, Fennel), Salt, Acid E330, Yeast Extract, Garlic Powder, Onion Powder, Herbs (Parsley), Natural Flavouring.<br><p><strong><span><meta charset=utf-8>Pickled Gherkin </span>Spud Dust Allergens in Bold.</strong><br><p>Store in a cool dry place out of direct sunlight.<p><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. </div></div>`,
      },
    ],
    selectedFlavors: [],
    selectedCrisps: [],
    tub: 0,
    tubPrice: 4.99,
    shakerPrice: 3.99,
    swiperInstance: null,
    modalHeader: null,
    modalText: null,
    modalClose: null,
    modalContinue: null,
    modalOpen: false,
    allergensContent: "",

    canUseStorage() {
      try {
        return typeof window.localStorage !== "undefined";
      } catch (error) {
        return false;
      }
    },

    persistState(state = this.getState()) {
      if (!this.canUseStorage()) {
        return;
      }

      try {
        window.localStorage.setItem(storageKey, JSON.stringify(state));
      } catch (error) {
        console.error("Error saving bundle kit state:", error);
      }
    },

    getPersistedState() {
      if (!this.canUseStorage()) {
        return null;
      }

      try {
        const savedState = window.localStorage.getItem(storageKey);

        if (!savedState) {
          return null;
        }

        return JSON.parse(savedState);
      } catch (error) {
        console.error("Error reading bundle kit state:", error);
        return null;
      }
    },

    clearPersistedState() {
      if (!this.canUseStorage()) {
        return;
      }

      try {
        window.localStorage.removeItem(storageKey);
      } catch (error) {
        console.error("Error clearing bundle kit state:", error);
      }
    },

    applyState(state = {}) {
      this.step = state.step ?? 1;
      this.bagsCount = state.bagsCount ?? 0;
      this.numberOf = 5 * this.bagsCount;
      this.shakeBagsCount = Math.min(
        state.shakeBagsCount ?? this.numberOf,
        this.numberOf,
      );
      this.tub = Math.min(state.tub ?? 0, this.bagsCount);

      if (state.selectedCrisps) {
        let total = 0;
        this.crisps.forEach((crisp) => {
          if (this.isCrispSoldOut(crisp.name)) {
            crisp.count = 0;
            return;
          }

          const savedCrisp = state.selectedCrisps.find(
            (c) => c.id === crisp.id,
          );

          if (savedCrisp) {
            if (total + savedCrisp.count > 10) {
              crisp.count = Math.max(0, 10 - total);
            } else {
              crisp.count = savedCrisp.count;
            }
            total += crisp.count;
          } else {
            crisp.count = 0;
          }
        });
      }

      if (state.selectedFlavors) {
        this.flavors.forEach((flavor) => {
          const savedFlavor = state.selectedFlavors.find(
            (f) => f.id === flavor.id,
          );
          flavor.count = savedFlavor ? savedFlavor.count : 0;
        });
      }

      this.bagsCount = this.crisps.reduce((sum, crisp) => sum + crisp.count, 0);
      this.numberOf = 5 * this.bagsCount;
      this.shakeBagsCount = Math.min(this.shakeBagsCount, this.numberOf);
      this.tub = Math.min(this.tub, this.bagsCount);
      this.shakerCount = this.flavors.reduce(
        (sum, flavor) => sum + flavor.count,
        0,
      );
    },

    syncState({ method = "replace" } = {}) {
      const state = this.getState();
      const nextUrl = new URL(window.location);
      nextUrl.searchParams.set("step", state.step);

      if (method === "push") {
        history.pushState(state, "", nextUrl);
      } else {
        history.replaceState(state, "", nextUrl);
      }

      this.persistState(state);
    },

    getStepUrl() {
      const url = new URL(window.location);
      const rawStep = url.searchParams.get("step");
      const parsedStep = Number.parseInt(rawStep, 10);
      const maxStep = this.steps.length + 2;

      if (Number.isNaN(parsedStep)) {
        return null;
      }

      return Math.min(Math.max(parsedStep, 1), maxStep);
    },

    init() {
      const currentUrl = new URL(window.location);
      const historyState = window.history.state;
      const persistedState = this.getPersistedState();
      const hasHistoryStep = Boolean(historyState?.step);

      if (hasHistoryStep) {
        this.applyState(historyState);
      } else {
        if (persistedState) {
          this.applyState(persistedState);
        }

        // New entries to the page always restart the flow at step 1,
        // while keeping previously selected products/counts.
        this.step = 1;
      }

      if (
        currentUrl.searchParams.has("step") ||
        persistedState ||
        hasHistoryStep
      ) {
        this.syncState();
      }

      setTimeout(() => {
        this.initSwiper();
        this.onScrollFlavors();
        this.onScrollNextButton();

        window.addEventListener("resize", this.onResize.bind(this));
        window.scrollTo(0, 0);
      }, 0);

      window.addEventListener("popstate", (event) => {
        if (event.state) {
          this.applyState(event.state);
          this.persistState(event.state);
        }
      });
    },

    getState() {
      const state = {
        step: this.step,
        bagsCount: this.bagsCount,
        shakeBagsCount: this.shakeBagsCount,
        tub: this.tub,
        selectedCrisps: this.crisps.map((crisp) => ({
          id: crisp.id,
          count: crisp.count,
        })),
        selectedFlavors: this.flavors.map((flavor) => ({
          id: flavor.id,
          count: flavor.count,
        })),
      };
      return state;
    },

    updateState() {
      this.syncState({ method: "push" });
    },

    onResize() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
      }
      this.initSwiper();
    },

    destroy() {
      window.removeEventListener("resize", this.onResize.bind(this));
    },

    waitForImagesToLoad(containerSelector) {
      const container = document.querySelector(containerSelector);
      if (!container) {
        return Promise.resolve();
      }

      const images = container.querySelectorAll("img");
      const imagePromises = Array.from(images).map((img) => {
        return new Promise((resolve) => {
          if (img.complete) {
            resolve();
          } else {
            img.addEventListener("load", resolve);
            img.addEventListener("error", resolve);
          }
        });
      });

      return Promise.all(imagePromises);
    },

    prepareFlavorGallery(event, imageUrl) {
      const mediaGallery = event.currentTarget.closest("media-gallery");
      const galleryModal = mediaGallery?.galleryModal;
      const galleryThumb = galleryModal?.querySelector(
        ".gallery-viewer__thumb",
      );

      if (!galleryThumb) {
        return;
      }

      galleryThumb.href = imageUrl;
      galleryThumb.dataset.zoomUrl = imageUrl;
      galleryThumb.setAttribute("data-zoom-url", imageUrl);

      const thumbImage = galleryThumb.querySelector(
        ".gallery-viewer__thumb-img",
      );

      if (thumbImage) {
        thumbImage.src = imageUrl;
      }
    },

    initSwiper() {
      const swiperElement = document.querySelector(".swiper");
      if (!swiperElement || swiperElement.offsetParent === null) {
        return;
      }

      this.waitForImagesToLoad(".swiper").then(() => {
        const slides = swiperElement.querySelectorAll(".swiper-slide");
        if (slides.length === 0) {
          return;
        }

        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
        }

        if (slides.length === 1) {
          swiperElement.style.padding = "0 0 0 0";
        }

        this.swiperInstance = new Swiper(".swiper", {
          loop: slides.length > 1,
          autoHeight: true,
          pagination: {
            el: ".swiper-pagination",
          },
        });
      });
      document.querySelector(".crisp-kit").classList.add("is-flavor");
    },

    setSubscribeAndSave() {
      this.subscribeAndSave = !this.subscribeAndSave;
      this.subscribeGift = false;
      this.initSwiper();
    },

    setSubscribeGift() {
      this.subscribeAndSave = false;
      url.searchParams.delete("subscribe");
      history.replaceState(null, "", url.toString());
      this.subscribeGift = !this.subscribeGift;
    },

    nextStep() {
      if (this.step === 3) {
        if (this.shakeBagsCount === 0) {
          this.modalHeader = "You’ve not selected any shaker.";
          this.modalText = "Are you sure you don’t want any Spud Dust shaker?";
          this.modalClose = "Oops, pick shaker";
          this.modalContinue = "I’m good, move on";
          this.openModal();
          return;
        }
      }
      if (this.step === 4) {
        if (this.shakeBagsCount === 0) {
          this.modalHeader = "You’ve not selected any shake bags.";
          this.modalText = "Are you sure you don’t want any shake bags?";
          this.modalClose = "Oops, add bags";
          this.modalContinue = "I’m good, move on";
          this.openModal();
          return;
        }
      }
      this.step++;
      this.updateState();
      this.init();
    },

    setStep(step) {
      if (step != 6 && step > this.step) {
        return;
      }
      this.step = step;
      this.updateState();
      this.init();
    },

    setBagsCount() {
      this.bagsCount = this.crisps.reduce((sum, f) => sum + f.count, 0);
      this.numberOf = 5 * this.crisps.reduce((sum, f) => sum + f.count, 0);

      this.shakeBagsCount = this.numberOf;

      if (this.shakeBagsCount > this.numberOf) {
        this.shakeBagsCount = this.numberOf * this.bagsCount;
      }

      if (this.tub > this.bagsCount) {
        this.tub = 0;
      }

      this.syncState();
    },

    setShakersCount() {
      this.shakerCount = this.flavors.reduce((sum, f) => sum + f.count, 0);
    },

    setHoveredCrisp(blurb) {
      this.hoveredCrisp = blurb;
    },

    getSortedCrisps() {
      return [...this.crisps].sort((a, b) => {
        const aSoldOut = this.isCrispSoldOut(a.name) ? 1 : 0;
        const bSoldOut = this.isCrispSoldOut(b.name) ? 1 : 0;
        return aSoldOut - bSoldOut;
      });
    },

    isCrispSoldOut(crispName) {
      return this.soldOutCrisps.includes(String(crispName).toLowerCase());
    },

    onScrollFlavors() {
      const header = document.querySelector(".crisp-kit-content-header");
      if (header) {
        document.querySelector(".crisp-kit").classList.add("is-flavor");
      } else {
        if (document.querySelector(".is-flavor")) {
          document.querySelector(".crisp-kit").classList.remove("is-flavor");
          this.initSwiper();
        }
        return;
      }

      document.addEventListener("scroll", () => {
        const scrollTop = header.offsetTop - document.body.scrollTop;
        if (scrollTop > 254) {
          header.classList.add("scrolled");
        } else {
          header.classList.remove("scrolled");
        }
      });
    },

    onScrollNextButton() {
      const nextStepContainer = document.querySelector(".next-step-container");
      if (!nextStepContainer) return;
      const checkSticky = () => {
        const rect = nextStepContainer.getBoundingClientRect();
        const isSticky = rect.bottom >= window.innerHeight;

        if (!isSticky) {
          nextStepContainer.classList.add("not-sticky");
        } else {
          nextStepContainer.classList.remove("not-sticky");
        }
      };
      checkSticky();
      window.addEventListener("scroll", checkSticky);
    },

    viewAllergens(id) {
      const allergen = this.flavors[id - 1].allergen;
      if (allergen) {
        this.modalHeader = this.flavors[id - 1].name;
        this.modalText = allergen;
        this.modalClose = "Close";
        this.modalContinue = "";
        this.openModal();
      }
    },

    crispAllergens(id) {
      const allergen = this.crisps[id - 1].allergen;
      if (allergen) {
        this.modalHeader = this.crisps[id - 1].name;
        this.modalText = allergen;
        this.modalClose = "Close";
        this.modalContinue = "";
        this.openModal();
      }
    },

    increaseCrisps(id) {
      const crisp = this.crisps.find((f) => f.id === id);
      if (crisp && this.isCrispSoldOut(crisp.name)) return;
      if (crisp.count >= 10) return;
      if (crisp) crisp.count++;
      this.setBagsCount();
      this.syncState();
    },

    decreaseCrisps(id) {
      const crisp = this.crisps.find((f) => f.id === id);
      if (crisp && crisp.count > 0) crisp.count--;
      this.setBagsCount();
      this.syncState();
    },

    getCrispsCount(id) {
      const crisp = this.crisps.find((f) => f.id === id);
      return crisp ? crisp.count : 0;
    },

    increaseFlavor(id) {
      const flavor = this.flavors.find((f) => f.id === id);
      if (flavor) flavor.count++;
      this.setShakersCount();
      this.syncState();
    },

    decreaseFlavor(id) {
      const flavor = this.flavors.find((f) => f.id === id);
      if (flavor && flavor.count > 0) flavor.count--;
      this.setShakersCount();
      this.syncState();
    },

    getFlavorCount(id) {
      const flavor = this.flavors.find((f) => f.id === id);
      return flavor ? flavor.count : 0;
    },

    setShakeBagsCount(count) {
      this.shakeBagsCount = count;
      this.setShakersCount();
      this.syncState();
    },

    setTub(count) {
      this.tub = count;
      if (count >= this.bagsCount) {
        return;
      }
      this.syncState();
    },

    openModal() {
      this.modalOpen = true;
      setTimeout(() => {
        const modalContent = document.querySelector(".modal-content");
        if (modalContent) {
          modalContent.scrollTop = 0;
        }
      }, 10);
    },

    closeModal() {
      this.modalOpen = false;
    },

    continueModal() {
      this.closeModal();
      this.step++;
      this.updateState();
      this.init();
    },

    getPrice() {
      let totalPrice = 0;

      this.crisps.forEach((c) => {
        totalPrice += c.count * this.bagPrice;
      });

      this.isFlavor =
        this.flavors.some((f) => f.count > 0) &&
        this.crisps.some((f) => f.count > 0);

      this.flavors.forEach((f) => {
        totalPrice += f.count * this.shakerPrice;
      });

      if (this.isFlavor) {
        totalPrice = totalPrice * 0.9;
      }

      console.log(this.isFlavor);

      totalPrice += this.tub * this.tubPrice;

      const originalPrice =
        this.bagsCount * this.bagPrice +
        this.shakerCount * this.shakerPrice +
        this.tub * this.tubPrice;

      if (originalPrice === totalPrice) {
        return "£" + totalPrice.toFixed(2);
      } else {
        return (
          "<s>£" +
          originalPrice.toFixed(2) +
          "</s>" +
          "£" +
          (Math.ceil(totalPrice * 100) / 100).toFixed(2)
        );
      }
    },

    addToCart() {
      const items = [];

      const packsOf5 = Math.floor(this.shakeBagsCount / 5);

      let packsDistributed = 0;

      this.crisps.forEach((c) => {
        if (c.count > 0) {
          const productsWithShakers = Math.min(
            c.count,
            packsOf5 - packsDistributed,
          );
          const productsWithoutShakers = c.count - productsWithShakers;

          if (productsWithShakers > 0) {
            items.push({
              id: String(c.itemId),
              quantity: Number(productsWithShakers),
              properties: {
                Shakebags: "Yes (5)",
              },
            });
            packsDistributed += productsWithShakers;
          }

          if (productsWithoutShakers > 0) {
            items.push({
              id: String(c.itemId),
              quantity: Number(productsWithoutShakers),
              properties: {
                Shakebags: "No",
              },
            });
          }
        }
      });

      this.flavors.forEach((f) => {
        if (f.count > 0) {
          items.push({ id: String(f.itemId), quantity: Number(f.count) });
        }
      });

      if (this.tub > 0) {
        items.push({ id: "56959261540739", quantity: this.tub });
      }

      this.cartLoading = true;

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      }).then((response) => {
        if (response.ok) {
          document.dispatchEvent(
            new CustomEvent("dispatch:cart-drawer:open", {
              bubbles: true,
            }),
          );
          document.dispatchEvent(
            new CustomEvent("dispatch:cart-drawer:refresh", {
              bubbles: true,
            }),
          );

          this.cartLoading = false;
          this.setStep(5);
          document.querySelector(".crisp-kit").classList.remove("crisp-kit");
          document.querySelector(".crips-kit-nav").style.display = "none";
          document
            .querySelector(".crisp-kit-full")
            .classList.remove("crisp-kit-full");
          document.body.classList.remove("fixed");
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
          this.clearPersistedState();
          history.pushState({}, "");
        } else {
          console.error("Error adding to cart:", response.statusText);
        }
      });
    },
  };
}
